/**
 * @description: 账单详情
 * @author: hwx
 * @update: lyr
 */
<template>
	<div class="bill-detail-wrap">
		<div class="bdw-page" v-show="!showBdwOrder&&!showCouponDetail&&!showBdwBookOrder">
			<div class="page-tit">账单详情</div>
			<div class="bdw-sub-tit">基本信息
				<div class="col-md-2 pull-right">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="openBdwTicket">开发票</button>
				</div>
			</div>
			<div class="row clearfix">
				<div class="col-md-6">
					<label class="col-md-3">账单序号：</label>
					<span class="col-md-9">{{theBdw.no}}</span>
					<label class="col-md-3">　账单号：</label>
					<span class="col-md-9">{{theBdw.bill_no}}</span>
					<label class="col-md-3">消费门店：</label>
					<span class="col-md-9">{{theBdw.shop_name}}</span>
					<label class="col-md-3">消费包厢：</label>
					<span class="col-md-9">{{theBdw.room_name}}</span>
					<label class="col-md-3">开房类型：</label>
					<span class="col-md-9">{{theBdw.order_title}}</span>
					<label class="col-md-3">开房时间：</label>
					<span class="col-md-9">{{theBdw.start_time}}</span>
					<label class="col-md-3">结束时间：</label>
					<span class="col-md-9">{{theBdw.end_time}}</span>
					<label class="col-md-3">消费时长：</label>
					<span class="col-md-9">{{theBdw.total_time}}</span>
					<label class="col-md-3" v-show="theBdw.hanging_account_username != ''">挂账担保人：</label>
					<span class="col-md-9" v-show="theBdw.hanging_account_username != ''">{{theBdw.hanging_account_username}} {{theBdw.hanging_account_worknumber}}</span>
					<label class="col-md-3" v-show="theBdw.remark != ''">备注：</label>
					<span class="col-md-9" v-show="theBdw.remark != ''">{{theBdw.remark}}</span>
					<label class="col-md-3">所属班次：</label>
					<span class="col-md-9">{{theBdw.shift_name}}</span>
				</div>
				<div class="col-md-6">
					<label class="col-md-3">消费金额：</label>
					<span class="col-md-9">{{theBdw.amount}}</span>
					<label class="col-md-3">应收款：</label>
					<span class="col-md-9">{{theBdw.actual_pay}}</span>
					<label class="col-md-3">未收款：</label>
					<span class="col-md-9">{{theBdw.unpay_amount}}</span>
					<label class="col-md-3" v-show="theBdw.goods_amount_total>0">酒水金额：</label>
					<span class="col-md-9" v-show="theBdw.goods_amount_total>0">{{theBdw.goods_amount_total}}</span>
					<label class="col-md-3" v-show="theBdw.reward_total>0">优惠券金额：</label>
					<span class="col-md-9" v-show="theBdw.reward_total>0">{{theBdw.reward_total}}<span class="text-blue" style="padding-left:10px;" @click="toCouponDetail(theBdw.unique_key)">详情</span></span>
					<label class="col-md-3" v-show="theBdw.vip_discounts>0">会员优惠：</label>
					<span class="col-md-9" v-show="theBdw.vip_discounts>0">{{theBdw.vip_discounts}}</span>
					<label class="col-md-3" v-show="theBdw.manager_discounts>0">经理优惠：</label>
					<span class="col-md-9" v-show="theBdw.manager_discounts>0">{{theBdw.manager_discounts}}</span>
					<label class="col-md-3" v-show="theBdw.manager_amount && theBdw.manager_amount != '-1.00'">经理实收：</label>
					<span class="col-md-9" v-show="theBdw.manager_amount && theBdw.manager_amount != '-1.00'">{{theBdw.manager_amount}}</span>
					<label class="col-md-3" v-show="theBdw.manager_name != ''">经理实收操作人：</label>
					<span class="col-md-9" v-show="theBdw.manager_name != ''">{{theBdw.manager_name}}</span>
					<label class="col-md-3" v-show="bdw_goods_list.refund_amount>0">退款金额：</label>
					<span class="col-md-9" v-show="bdw_goods_list.refund_amount>0">{{bdw_goods_list.refund_amount}}</span>
					<label class="col-md-3" v-show="theBdw.invoice_print==1">发票情况：</label>
					<span class="col-md-9" v-show="theBdw.invoice_print==1">已开</span>
					<label class="col-md-3">翻台次数：</label>
					<span class="col-md-9">{{theBdw.room_open_count}}次</span>
					<label class="col-md-3">酒水服务费：</label>
					<span class="col-md-9">{{theBdw.service_charge}}</span>
					<label class="col-md-3">开房人：</label>
					<span class="col-md-9">{{theBdw.open_room_admin_name}}</span>
					<label class="col-md-3">价格策略：</label>
					<span class="col-md-9">{{theBdw.goods_price_rule_name}}</span>
				</div>
			</div>
			<div class="bdw-det-ul">
				<div class="bdw-sub-tit">其他金额</div>
				<ul>
					<li>低消金额：{{theBdw.minimum_amount}}</li>
					<li>非低消金额：{{theBdw.no_minimum_amount}}</li>
					<li>抹零金额：{{theBdw.ml_amount}}</li>
					<li>赠送商品金额：{{theBdw.present_amount_total}}</li>
				</ul>
			</div>
			<div class="bdw-sub-tit clearfix" v-show="theBdw.pay_log && theBdw.pay_log.length != '0'">付款记录</div>
			<div class="bdw-det-ul">
				<ul>
					<li class="clearfix" v-for="(item, index) in theBdw.pay_log" :key="index">
						<div class="col-md-4">{{item.create_time}}</div>
						<div class="col-md-4">
							<span v-if="item.pay_platform_num == '16'">挂账人：</span>
							<span v-else>收款人：</span>
							{{item.admin_name}}
						</div>
						<div class="col-md-4">{{item.pay_platform}}：￥{{item.actual_pay}}</div>
					</li>
				</ul>
			</div>
			<div class="bdw-sub-tit clearfix" v-show="theBdw.manager_reason != ''">经理实收原因：{{theBdw.manager_reason}}</div>
			<div class="bdw-sub-tit clearfix" v-show="theBdw.refund_log && theBdw.refund_log.length != '0'">退款记录</div>
			<div class="bdw-det-ul">
				<ul>
					<li class="clearfix" v-for="(item, index) in theBdw.refund_log" :key="index">
						<div class="col-md-3">{{item.create_time}}</div>
						<div class="col-md-3">退款人：{{item.refund_admin_name}}</div>
						<div class="col-md-3">操作人：{{item.admin_name}}</div>
						<div class="col-md-3">{{item.pay_platform}}：￥{{item.refund_amount}}</div>
					</li>
				</ul>
			</div>
			<div class="bdw-det-ul" style="margin: 30px 0 0;" v-show="theBdw.cancel_id > 0">
				<ul class="clearfix">
					<li>
						<div class="col-md-5">取消开房时间：{{theBdw.cancel_time}}</div>
						<div class="col-md-5">取消人：{{theBdw.cancel_admin}}</div>
					</li>
					<li>
						<div class="col-md-5">取消原因：{{theBdw.cancel_remark}}</div>
					</li>
				</ul>
			</div>
			<div class="row bdw-det-row" v-show="theBdw.before_room_id != 0">
				<div class="bdw-sub-tit">转房信息</div>
				<label class="col-md-1">已转房：</label>
				<span class="col-md-9">{{theBdw.change_room_msg}}</span>
			</div>
			<div class="row bdw-det-row" v-show="theBdw.book_no != 0">
				<div class="bdw-sub-tit">预定信息</div>
				<label class="col-md-1">已预定：</label>
				<div class="col-md-9">
					<span>{{theBdw.book_no}}</span>
					<span class="color-txt" @click="goBdwBookOrder(theBdw.book_id)">查看预定详情</span>
				</div>
			</div>
			<div class="bdw-sub-tit clearfix" v-show="theBdw.refund_log && theBdw.order_info.length != '0'">消费订单</div>
			<div class="bdw-det-ul">
				<ul>
					<li class="clearfix" v-for="item in theBdw.order_info" :key="item.id">
						<div class="bdw-order-big">{{item.time}}</div>
						<div class="bdw-order-small">{{item.title}}</div>
						<div class="bdw-order-small">{{item.actual_pay}}</div>
						<div class="bdw-order-small">{{item.pay_platform_show}}</div>
						<div class="bdw-order-big">{{item.id}}</div>
						<div class="bdw-det-order bdw-order-small" @click="goBdwOrder(item.id)">查看订单详情</div>
					</li>
				</ul>
			</div>
			<div class="table-responsive">
				<div class="bdw-sub-tit">已收款</div>
				<table class="table table-bordered table-hover" data-pagination="true" ref="bdw_pay_goods"></table>
				<div class="bdw-sub-tit">未收款</div>
				<table class="table table-bordered table-hover" data-pagination="true" ref="bdw_unpay_goods"></table>
				<div class="bdw-sub-tit">取酒商品</div>
				<table class="table table-bordered table-hover" data-pagination="true" ref="bdw_take_goods"></table>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="bdw_ticket_log" v-show="theBdw.invoice_print == 1"></table>
			</div>
			<div>
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="$emit('backBdwPre')">返回</button>
			</div>
		</div>
		<div class="bdw-order" v-show="showBdwOrder&&!showCouponDetail">
			<orderDetail ref="bdw_order_det" @backOdwPre="showBdwOrder = false"></orderDetail>
		</div>
		<div class="bdw-order" v-show="showBdwBookOrder&&!showCouponDetail">
			<reserveDetail ref="bdw_book_det" @backReservePre="showBdwBookOrder = false"></reserveDetail>
		</div>
		<!-- 优惠券使用详情 -->
		<div class="coupon-detail" v-show="showCouponDetail">
			<div class="page-tit">优惠券使用详情</div>
			<div class="gray-block" v-for="item in couponDetail">
				<div class="coupon-name">{{item.name}}</div>
				<el-row>
				  <el-col :span="12"><span class="el-label">使用时间：</span>{{item.create_time}}</el-col>
				  <el-col :span="12"><span class="el-label">优惠金额：</span>{{item.use_amount}}</el-col>
				</el-row>
				<el-row>
				  <el-col :span="12"><span class="el-label">发券时间：</span>{{item.reward_time}}</el-col>
				  <el-col :span="12"><span class="el-label">发券方式：</span>{{item.reward_send_type}}</el-col>
				</el-row>
				<el-row>
				  <el-col :span="12"><span class="el-label">卡券类型：</span>{{item.reward_type}}</el-col>
				  <el-col :span="12"><span class="el-label">活动名称：</span>{{item.activity_name}}</el-col>
				</el-row>
				<el-row>
				  <el-col :span="12"><span class="el-label">用户昵称：</span>{{item.nickname}}</el-col>
				  <el-col :span="12"><span class="el-label">会员卡号：</span>{{item.vip_card}}</el-col>
				</el-row>
				<el-row>
				  <el-col :span="12"><span class="el-label">会员手机号：</span>{{item.vip_mobile}}</el-col>
				  <el-col :span="12"><span class="el-label">会员姓名：</span>{{item.vip_name}}</el-col>
				</el-row>
			</div>
			<div>
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="showCouponDetail=false">返回</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import orderDetail from '@/components/order_detail.vue';
	import reserveDetail from '@/components/reserve_detail.vue'
	export default {
		name: 'order_manage',
		data() {
			return {
				showBdwOrder: false,
				showBdwBookOrder: false,
				theBdw: {},
				bdw_goods_list: [],
				bdw_take_goods_list: [],
				bdw_tickets_list: [],
				showCouponDetail: false, // 显示优惠券详情
				couponDetail: [], // 优惠券详情
			}
		},
		components: {
			"orderDetail": orderDetail,
			"reserveDetail": reserveDetail
		},
		mounted: function() {

		},
		methods: {
			// 获取账单详情
			getBdwDetail: function(bill_no) {
				let _this = this;
				var layIndex = layer.load(0, {
					shade: [0.1, '#ececec']
				});
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"bill_no": bill_no
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Bill/getDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.theBdw = data.response.result;
							_this.bdw_goods_list = data.response.result.goods_info;
							$(_this.$refs.bdw_pay_goods).bootstrapTable("destroy");
							$(_this.$refs.bdw_unpay_goods).bootstrapTable("destroy");
							_this.initBdwGoods();
							_this.bdw_take_goods_list = data.response.result.take_goods_info;
							_this.initBdwTakeGoods();
							if(data.response.result.invoice_print == "1") {
								_this.bdw_tickets_list = data.response.result.invoice_info;
								$(_this.$refs.bdw_ticket_log).bootstrapTable("destroy");
								_this.initBdwTicket();
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
						layer.close(layIndex);
					},
					error: function(err) {
						layer.msg("出错啦");
						layer.close(layIndex);
					}
				});
			},
			// 开发票
			openBdwTicket: function() {
				let _this = this;
				if(Number(_this.theBdw.amount) <= 0){
					layer.msg("实收金额为0,不需要开发票");
					return;
				}
				layer.confirm("", {
					title: "发票金额",
					closeBtn: 0,
					skin: 'billalert',
					btn: ['确定', '取消'],
					content: "<p>请输入当前账单发票金额</p>" + "<input type='text' class='form-control' placeholder='0.00' id='tickectmoney' value=" + _this.theBdw.amount + " />"
				}, function() {
					let invoice_amount = $("#tickectmoney").val();
					if(Number(invoice_amount) > Number(_this.theBdw.amount)) {
						layer.msg("发票金额不能大于实收金额");
						return;
					}
					_this.printBdwTicket(_this.theBdw.bill_no, invoice_amount);
				});
			},
			// 打印账单
			printBdwTicket: function(bill_no, invoice_amount) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"bill_no": bill_no || "",
							"invoice_amount": invoice_amount || 0
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Bill/printInvoice",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							layer.msg("开发票成功！");
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 初始化商品表格
			initBdwGoods: function() {
				let _this = this;
				$(_this.$refs.bdw_pay_goods).bootstrapTable({
					pagination: false,
					columns: [{
						field: "",
						title: "",
						width: "3%",
						formatter: function(value, row, index) {
							return '';
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						align: "left",
						width: "28%"
					}, {
						field: "quantity",
						title: "商品数量",
						width: "24%",
						formatter: function(value, row) {
							return row.quantity + row.goods_unit_name;
						}
					}, {
						field: "price",
						title: "单价",
						width: "14%"
					}, {
						field: "amount",
						title: "金额",
						width: "14%"
					}, {
						field: "admin_name",
						title: "操作人",
						width: "14%"
					}, {
						field: 'state1',
						width: '5%',
						align: 'left',
						formatter: function(value, row, index) {
							if(row.detail.length > 0) {
								return "<a href='javascript:' class=\"detail-icon\" ><i class=\"glyphicon glyphicon-plus icon-plus\"></i></a>";
							} else {
								return '';
							}
						}
					}],
					data: _this.bdw_goods_list.paid_data,
					icons: {
						paginationSwitchDown: 'glyphicon-collapse-down icon-chevron-down',
						paginationSwitchUp: 'glyphicon-collapse-up icon-chevron-up',
						refresh: 'glyphicon-refresh icon-refresh',
						toggle: 'glyphicon-list-alt icon-list-alt',
						columns: 'glyphicon-th icon-th',
						detailOpen: 'glyphicon-plus icon-plus',
						detailClose: 'glyphicon-minus icon-minus'
					},
					// 注册加载子表的事件
					onExpandRow: function(index, row, $detail) {
						_this.initSubBdwGoods(index, row, $detail);
					}
				});

				$(_this.$refs.bdw_unpay_goods).bootstrapTable({
					pagination: false,
					columns: [{
						field: "",
						title: "",
						width: "3%",
						formatter: function(value, row, index) {
							return '';
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						align: "left",
						width: "28%"
					}, {
						field: "quantity",
						title: "商品数量",
						width: "24%",
						formatter: function(value, row, index) {
							return row.quantity + row.goods_unit_name;
						}
					}, {
						field: "price",
						title: "单价",
						width: "14%"
					}, {
						field: "amount",
						title: "金额",
						width: "14%"
					}, {
						field: "admin_name",
						title: "下单操作人",
						width: "14%"
					}, {
						field: 'state1',
						width: '5%',
						align: 'left',
						formatter: function(value, row, index) {
							if(row.detail.length > 0) {
								return "<a href='javascript:' class=\"detail-icon\" ><i class=\"glyphicon glyphicon-plus icon-plus\"></i></a>";
							} else {
								return '';
							}
						}
					}],
					data: _this.bdw_goods_list.unpaid_data,
					icons: {
						paginationSwitchDown: 'glyphicon-collapse-down icon-chevron-down',
						paginationSwitchUp: 'glyphicon-collapse-up icon-chevron-up',
						refresh: 'glyphicon-refresh icon-refresh',
						toggle: 'glyphicon-list-alt icon-list-alt',
						columns: 'glyphicon-th icon-th',
						detailOpen: 'glyphicon-plus icon-plus',
						detailClose: 'glyphicon-minus icon-minus'
					},
					// 注册加载子表的事件
					onExpandRow: function(index, row, $detail) {
						_this.initSubBdwGoods(index, row, $detail);
					}
				});
				$(".detail-icon").trigger("click");
			},
			initSubBdwGoods: function(index, row, $detail) {
				let str = '';
				if(row.detail.length > 0) {
					$.each(row.detail, function(k, v) {
						str += '<li class="clearfix" style="height: 30px; line-height: 30px;"><div style="float: left; width: 31%; text-align: left;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'+ v.goods_name +'</div><div style="float: left; width: 24%">'+ v.quantity + v.goods_unit_name +'</div><div style="float: left; width: 14%">'+ v.price +'</div><div style="float: left; width: 14%">'+ v.amount +'</div></li>';
					});
					$detail.html('<ul>'+ str +'</ul>');
				} else {
					$detail.html('<div style="float: left; width: 20%">没有找到匹配的记录</div>');
				}
			},
			// 取酒商品
			initBdwTakeGoods: function() {
				let _this = this;
				$(_this.$refs.bdw_take_goods).bootstrapTable("destroy");
				$(_this.$refs.bdw_take_goods).bootstrapTable({
					pagination: false,
					columns: [{
						field: "goods_name",
						title: "商品名称",
						width: "50%"
					}, {
						field: "quantity",
						title: "商品数量",
						width: "50%"
					}],
					data: _this.bdw_take_goods_list
				});
			},
			// 已开发票表格
			initBdwTicket: function() {
				let _this = this;
				$(_this.$refs.bdw_ticket_log).bootstrapTable({
					pagination: false,
					columns: [{
						field: "time",
						title: "时间",
						width: "40%"
					}, {
						field: "admin_name",
						title: "操作人",
						width: "30%"
					}, {
						field: "invoice_amount",
						title: "开票金额",
						width: "30%"
					}],
					data: _this.bdw_tickets_list
				});
			},
			// 跳转到订单详情
			goBdwOrder: function(order_id) {
				this.$refs.bdw_order_det.getOdwDetail(order_id);
				this.showBdwOrder = true;
			},

			// 跳转到预定详情
			goBdwBookOrder: function(order_id) {
				this.$refs.bdw_book_det.getBookDetail(order_id);
				this.showBdwBookOrder = true;
			},

			// 获取优惠券详情
			toCouponDetail(unique_key) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"unique_key": unique_key
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Bill/getRewardList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							_this.couponDetail = data.response.result
							_this.showCouponDetail = true
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.bill-detail-wrap {
		.bdw-page {
			.bdw-sub-tit {
				margin: 30px 0 15px 0px;
				font-size: 18px;
			}
			.col-md-6 {
				padding-left: 0;
				font-size: 14px;
				>label {
					height: 40px;
					line-height: 40px;
					padding: 0;
					margin-bottom: 0px;
					text-align: right;
				}
				>span {
					height: 40px;
					line-height: 40px;
					padding-left: 0;
					padding-left: 0;
					margin-bottom: 0px;
				}
			}
			.bdw-det-ul {
				ul {
					padding: 0 0 0 15px;
				}
				li {
					line-height: 30px;
					div {
						float: left;
						padding: 0 15px;
						font-size: 14px;
					}
					.bdw-det-order {
						color: #009af0;
						cursor: pointer;
					}
					.bdw-order-big {
						width: 23%;
					}
					.bdw-order-small {
						width: 13%;
					}
				}
			}
			.bdw-det-row {
				label {
					padding: 0;
					font-size: 14px;
					text-align: right;
				}
				span {
					padding: 0;
					font-size: 14px;
				}
				.color-txt {
					color: #009af0;
					cursor: pointer;
					padding: 10px 15px;
				}
			}

			.glyphicon-plus:before {
				content: '';
				display: block;
				width: 11px;
				height: 20px;
				background: url(../assets/images/order_manage/turn_down.png) left center no-repeat;
				cursor: pointer;
			}
			.glyphicon-minus:before {
				content: '';
				display: block;
				width: 11px;
				height: 20px;
				background: url(../assets/images/order_manage/turn_top.png) left center no-repeat;
				cursor: pointer;
			}
		}

		.gray-block {
			margin-bottom: 20px;
			padding: 10px;
			background: #efefef;
			.el-row {
				margin: 12px 0;
			}
			.coupon-name {
				font-size: 18px;
				font-weight: bold;
			}
		}
	}
</style>